import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, Row, Label, FormGroup, InputGroup } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";
import CustomMultipleDateRange from "../../CustomMultipleDateRange/CustomMultipleDateRange";

const InvoiceItems = ({ num, keys, onDelete }) => {
  return ( // justify-content-between 
    <StyledRow className="fade-in-custom-animate">
      <Col sm={6} className="mt-1 mb-1">
        <label htmlFor=""> Service name:</label>
        <AvField
          name={`service-name_${keys}`}
          placeholder="Service name"
          type="text"
          className="form-control"
          validate={{
            required: {
              value: true,
              errorMessage: "Please, enter a service name",
            },
          }}
        />
      </Col>
      {/* <Col sm={4} className="mt-1 mb-1">
        <label htmlFor="">Quantity:</label>
        <AvField
          name={`quantity|${keys}`}
          placeholder="Quantity..."
          type="number"
          className="form-control"
          validate={{
            required: {
              value: true,
              errorMessage: "Please, enter a quantity",
            },
          }}
        />
      </Col> */}
      <Col sm={6} lg={6} className="mt-1 mb-1">
        <label htmlFor="">Sum:</label>
        <AvField
          name={`sum_${keys}`}
          placeholder="Sum..."
          type="number"
          className="form-control"
          validate={{
            required: {
              value: true,
              errorMessage: "Please, enter a sum",
            },
          }}
        />
      </Col>
      <Col sm={12} lg={6}>
        <PickerStyled>
          <Label htmlFor="">Date from:</Label>
          <FormGroup className="mb-1">
            <CustomMultipleDateRange
              placeholder="Select date from..."
              name={`date-from_${keys}`}
              datePickerType={"calendar"}
            // errorText="Date from is required!"
            // required
            />
          </FormGroup>
        </PickerStyled>
      </Col>
      <Col sm={12} lg={6}>
        <PickerStyled>
          <Label htmlFor="">Date to:</Label>
          <FormGroup className="mb-1">
            <CustomMultipleDateRange
              placeholder="Select date to..."
              name={`date-to_${keys}`}
              datePickerType={"calendar"}
            // errorText="Date to is required!"
            // required
            />
          </FormGroup>
        </PickerStyled>
      </Col>
      <Col lg={12} style={{ display: num === 1 ? "none" : "flex", justifyContent: 'end' }}>
        <button
          type="button"
          className="btn btn-danger btn-sm"
          style={{ marginTop: "27px" }}
          onClick={onDelete}
        >
          <i className="mdi mdi-trash-can d-block font-size-17" />
        </button>
      </Col>
    </StyledRow>
  );
};

const StyledRow = styled(Row)`
  margin: 0;
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid #dcdde2;
  box-sizing: border-box;
  border-radius: 3px;
`;

const PickerStyled = styled(InputGroup)`
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }

`;

InvoiceItems.propTypes = {
  keys: PropTypes.string.isRequired,
  num: PropTypes.number.isRequired,
  onDelete: PropTypes.func,
};

export default InvoiceItems;
